// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaPropertyByName,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(schema, "X_DAY_TYPE_OF_CONTINUOUS_ABSENCE");

  return {
    ...baseSchema,
    properties: {
      ...baseSchema.properties,
      xDayTypeOfContinuousAbsence: {
        required: findSchemaRequired(typeSchema, "xDayTypeOfContinuousAbsence"),
        title: "X Day Type Of Continuous Absence",
        properties: {
          days: {
            type: "number",
            multipleOf: 0.01,
            title: "Days",
          },
          dayType: findSchemaPropertyByName(typeSchema, "xDayTypeOfContinuousAbsence", "dayType"),
          fteProRata: findSchemaPropertyByName(
            typeSchema,
            "xDayTypeOfContinuousAbsence",
            "fteProRata",
          ),
        },
        type: "object",
      },
    },
    required: [...baseSchema.required, "xDayTypeOfContinuousAbsence"],
  };
};

export const uiSchema = (t: (s: string) => string) => ({
  ...baseUiSchema(t),
  xDayTypeOfContinuousAbsence: {
    fteProRata: {
      "ui:title": t("ALERTS_ALERT_FTE_PRO_RATA_ADJUSTMENT"),
      "ui:widget": "toggle",
    },
  },
});

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
